// extracted by mini-css-extract-plugin
export default {"field-info":"SendVoucherModal_field-info__gwgG5","field-info-mobile":"SendVoucherModal_field-info-mobile__k+NRu","modal-footer":"SendVoucherModal_modal-footer__bzCVt"};